<div class="question-type__text">
  <h1 class="fs__xxl">Open Ended Question</h1>
  <p class="fs__md">
    Participants are given a multi-line text input field to provide their response in detail.Improvement: Allows participants to enter detailed responses in a
    multi-line text field. Useful for collecting qualitative feedback.
  </p>
  <h2 class="fs__lg">Example</h2>
  <p class="fs__md">Please tell us why you gave that rating?</p>
</div>
